export const initialModel = {
    isShowModal: false as boolean,
    data: "" as string,
    schemaOrdering: "" as string,
    testValue: 30 as number,
    aiModelId: "" as string,
    isCleaning: false as boolean,
    isProcessing: false as boolean,

}

export const initialState = {
    modelData: initialModel,
};

export type ModelDataStateType = typeof initialState;

